export default "__VITE_ASSET__2b790b8f__"